var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar",style:({background: _vm.themesColor})},[_c('el-scrollbar',{staticStyle:{"height":"calc(100% - 50px)"}},[_c('Logo'),_c('Menu',{ref:"menu"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }